<template>
    <MainSlot :body_classes="header_classes"
              :background_image_url="event_image_url"
    >
        <div class="container page_bg">
            <!-- content event -->
            <div
                v-show="is_loaded_page"
                class="row main_event" ref="main_container">

                <div class="top_event">
                    <div class="event_text">
                        {{ $t("EventPastDetails['My calendar']") }} / {{ $t("EventPastDetails['Past events']") }}
                    </div>
                    <!-- image event -->
                    <div class="card_wrapper">
                        <img :src="event_image_url" alt="event image">
                        <div class="content_info">
                            {{ event.title }}
                        </div>
                    </div>
                </div>

                <!-- tags -->
                <div v-if="event.tags.length" class="tags_wrapper input-field col s12">
                    <div v-for="tag of event.tags" class="app_tag">
                        <img src="../assets/img/tag-icon.svg" class="left" alt="tag-icon" aria-hidden="true">
                        <div class="title">{{ tag.title }}</div>
                    </div>
                </div>
                <!-- 2 -->
                <div class="row second_row">
                    <!-- block_dress -->
                    <div v-if="event.dresscode || this.desc_event" class="block_dress_desc flex_vertical">
                        <DresscodeWidget v-if="event.dresscode" :event="event"></DresscodeWidget>
                        <ContactPersonWidget :event="event"/>
                        <conversation-starters-widget :event="event"/>
                        <div v-if="this.desc_event" class="ev_description">
                            {{ this.desc_event }}
                        </div>
                        <!-- button description -->
                        <div v-if="desc_event_view"
                             class="view_all text-action desc_view" @click="changeDescriptionEvent">
                            {{
                                this.show_desc ? $t("EventPastDetails['View all']") : $t("EventPastDetails['View less']")
                            }}
                        </div>
                    </div>
                    <!-- data event -->
                    <div class="right_col">
                        <EventInfoWidget
                            :event="event"
                            :btn_wrapper="{view_btn_wrapper: false}"
                        ></EventInfoWidget>
                    </div>
                    <!-- friends -->
                    <div class="block_friends">
                        <div class="row list_friends">
                            <!-- title -->
                            <div v-if="users.list.length" class="title_friends">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0)">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M19.4666 2.5V2.50013C19.4666 2.90007 19.4666 6.21083 18.4279 8.01371C18.8215 8.01432 19.2295 8.01652 19.6589 8.01884L19.6599 8.01884L19.6603 8.01884C20.0669 8.02104 20.4927 8.02333 20.9437 8.02448C22.7906 8.02919 24.2301 9.65744 23.9689 11.4859L22.8348 19.4243C22.6236 20.9022 21.3579 22 19.8649 22H18.7853C18.8124 21.8807 18.8348 21.7594 18.8524 21.6364L19.9866 13.698C20.3796 10.9466 18.2173 8.53146 15.4802 8.52449L15.0862 8.5232C15.2172 7.95131 15.3019 7.39292 15.3592 6.90617C15.4993 5.71575 15.4993 4.71916 15.4993 4.50038C15.4993 3.5077 15.1377 2.5994 14.5391 1.90009C14.8078 0.809117 15.7927 0 16.9666 0C18.3473 0 19.4666 1.11929 19.4666 2.5Z"
                                              fill="#9235A1"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M13.9998 4.50013V4.5C13.9998 3.11929 12.8805 2 11.4998 2C10.1191 2 8.99982 3.11929 8.99982 4.5C8.99982 5.78887 8.12859 9.02839 3.94559 10.6738C3.81035 10.2817 3.43807 10 3 10H1C0.447715 10 0 10.4477 0 11V22C0 22.5523 0.447715 23 1 23H3C3.52746 23 3.95954 22.5916 3.99732 22.0738C4.41019 22.135 4.79803 22.2307 5.15747 22.3475C5.65797 22.5102 6.1584 22.6938 6.66039 22.878L6.66046 22.878C8.18218 23.4364 9.71815 24 11.3135 24H14.3981C15.8911 24 17.1568 22.9022 17.368 21.4243L18.5021 13.4859C18.7633 11.6574 17.3238 10.0292 15.4769 10.0245C15.0259 10.0233 14.6001 10.021 14.1935 10.0188L14.1931 10.0188C13.7634 10.0165 13.355 10.0143 12.9611 10.0137C13.9998 8.21083 13.9998 4.90007 13.9998 4.50013Z"
                                              fill="#9235A1"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0">
                                            <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <div>{{ users.total_count }} {{ $t("EventPastDetails['friends']") }}</div>
                            </div>
                            <!-- friend -->
                            <div class="align_block">
                                <div v-for="(user, key) in users.list" :key="key"
                                     class="col s12 m6 l6 align_friend"
                                     @click="openUserModal(user.id)"
                                >
                                    <div class="friend-item">
                                        <div class="first-block"
                                             :style="{background: background_image_url(user) }"
                                        >
                                            <div class="container">
                                                <div class="image-block">
                                                    <div class="avatar-image"
                                                         :style="{backgroundImage: `url(${getAvatar(user)})` }"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="second-block"></div>
                                        <div class="third-block">
                                            <div class="name">{{ `${user.first_name} ${user.last_name}` }}</div>
                                            <div class="block-item">
                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0)">
                                                        <rect y="6" width="3" height="6" rx="1.5" fill="#9235A1"/>
                                                        <rect x="9" y="2" width="3" height="10" rx="1.5"
                                                              fill="#9235A1"/>
                                                        <rect x="4.5" width="3" height="12" rx="1.5" fill="#9235A1"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0">
                                                            <rect width="12" height="11.9993" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                {{ user.attended_events_count || 0 }}
                                                {{ user.attended_events_count === 1 ? $t("Profile['event attended']") : $t("Profile['events attended']") }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal user -->
        <div id="modal_user" ref="modal_user" class="modal content-width">
            <div class="modal_header"
                 :style="{background: getUserBackground(this.users.user) }"
            >
                <svg class="modal-close"
                     @click="closeUserModal"
                     width="13" height="13" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.5 10.5L1.5 1.5" stroke="#FA604A" stroke-width="3" stroke-linecap="round"
                          stroke-linejoin="round"/>
                    <path d="M1.5 10.5L10.5 1.5" stroke="#FA604A" stroke-width="3" stroke-linecap="round"
                          stroke-linejoin="round"/>
                </svg>
            </div>
            <div class="modal-content" id="user_modal_content">
                <div class="modal_body">
                    <!-- ava and content -->
                    <div class="user_info">

                        <div class="user_ava"
                             :style="{background: avatarBackground(users.user)}"
                        ></div>

                        <div class="user_about more_500">
                            <!-- full name -->
                            <div class="full_name">{{ users.selected_user['first_name'] }}
                                {{ users.selected_user['last_name'] }}
                            </div>
                            <!-- profession -->
                            <div v-if="users.selected_user.profession && users.selected_user.profession.title"
                                 class="profession">
                                {{ users.selected_user.profession.title }}
                            </div>
                            <!-- location -->
                            <div v-if="users.selected_user.location && users.selected_user.location.title"
                                 class="block-item">
                                <svg width="12" height="15" viewBox="0 0 10 13" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M7.27273 4.99971C7.27273 6.25484 6.25519 7.27231 5 7.27231C3.74481 7.27231 2.72727 6.25484 2.72727 4.99971C2.72727 3.74459 3.74481 2.72712 5 2.72712C6.25519 2.72712 7.27273 3.74459 7.27273 4.99971ZM10 4.99971C10 7.63518 8.45634 9.49885 6.04711 11.6078C5.44781 12.1324 4.55219 12.1324 3.95289 11.6078C1.54366 9.49885 0 7.63518 0 4.99971C0 2.23845 2.23858 0 5 0C7.76142 0 10 2.23845 10 4.99971Z"
                                          fill="white"/>
                                </svg>
                                <span class="block-item-text">{{ users.selected_user.location.title }}</span>
                            </div>
                            <!-- events subscription -->
                            <div class="block-item">
                                <svg width="14" height="14" viewBox="0 0 12 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0)">
                                        <rect y="6" width="3" height="6" rx="1.5" fill="white"/>
                                        <rect x="9" y="2" width="3" height="10" rx="1.5" fill="white"/>
                                        <rect x="4.5" width="3" height="12" rx="1.5" fill="white"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0">
                                            <rect width="12" height="11.9993" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <span v-if="users.selected_user" class="block-item-text">{{
                                        users.selected_user.attended_events_count || 0
                                    }} {{ users.selected_user.attended_events_count === 1 ? $t("Profile['event attended']") : $t("Profile['events attended']") }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="user_about less_500">
                        <!-- full name -->
                        <div class="full_name">{{ users.user['first_name'] }} {{ users.user['last_name'] }}</div>
                        <!-- profession -->
                        <div v-if="users.user['profession'] && users.user['profession'].title" class="profession">
                            {{ users.user['profession'].title }}
                        </div>
                        <div>
                            <!-- location -->
                            <div v-if="users.user['location'] && users.user['location'].title" class="block-item">
                                <svg width="14" height="20" viewBox="0 0 10 13" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M7.27273 4.99971C7.27273 6.25484 6.25519 7.27231 5 7.27231C3.74481 7.27231 2.72727 6.25484 2.72727 4.99971C2.72727 3.74459 3.74481 2.72712 5 2.72712C6.25519 2.72712 7.27273 3.74459 7.27273 4.99971ZM10 4.99971C10 7.63518 8.45634 9.49885 6.04711 11.6078C5.44781 12.1324 4.55219 12.1324 3.95289 11.6078C1.54366 9.49885 0 7.63518 0 4.99971C0 2.23845 2.23858 0 5 0C7.76142 0 10 2.23845 10 4.99971Z"
                                          fill="#9235A1"/>
                                </svg>
                                <span class="block-item-text">{{ users.user['location'].title }}</span>
                            </div>
                            <!-- events subscription -->
                            <div class="block-item">
                                <svg width="20" height="17" viewBox="0 0 12 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0)">
                                        <rect y="6" width="3" height="6" rx="1.5" fill="#9235A1"/>
                                        <rect x="9" y="2" width="3" height="10" rx="1.5" fill="#9235A1"/>
                                        <rect x="4.5" width="3" height="12" rx="1.5" fill="#9235A1"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0">
                                            <rect width="12" height="11.9993" fill="#9235A1"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <span v-if="users.user" class="block-item-text">{{
                                        users.user['attended_events_count'] || 0
                                    }} {{ users.user.attended_events_count === 1 ? $t("Profile['event attended']") : $t("Profile['events attended']") }}</span>
                            </div>
                        </div>

                    </div>
                    <!-- tags -->
                    <div v-if="users.tags.length" class="user_tags">
                        <div class="tags">
                            <div v-for="(tag, key) in users.tags" :key="key" class="tag-item">
                                <div class="tag-content">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M10.6129 0C11.3789 0 12 0.621038 12 1.38713V4.75443C12 5.28575 11.789 5.79529 11.4133 6.17105L6.1724 11.4132C5.38976 12.1943 4.12242 12.1948 3.33874 11.4141L0.588103 8.66751C-0.195143 7.88585 -0.196148 6.61715 0.585773 5.83407L5.82581 0.587735C6.20163 0.211441 6.71166 0 7.24345 0H10.6129ZM8.91743 2.1591C8.40673 2.1591 7.99275 2.57311 7.99275 3.08384C7.99275 3.59455 8.40673 4.00857 8.91743 4.00857C9.42814 4.00857 9.84219 3.59455 9.84219 3.08384C9.84219 2.57311 9.42814 2.1591 8.91743 2.1591Z"
                                            fill="#9235A1"/>
                                    </svg>
                                    <span class="tag-text">{{ tag.title }}</span>
                                </div>
                            </div>
                            <div class="points_tag">...</div>
                        </div>
                    </div>
                    <!-- social -->
                    <div v-if="users.user.social" class="user_soc" id="user_soc">
                        <!-- WhatsApp -->
                        <div v-if="checkSocialNetwork('WhatsApp')" class="social-item">
                            <img src="../assets/img/whatsapp.svg" class="social-img">
                            <div class="social-info">
                                <div class="social-name">WhatsApp</div>
                                <div class="social-number">{{ getSocialNetwork('WhatsApp') }}</div>
                            </div>
                        </div>
                        <!-- Snapchat -->
                        <div v-if="checkSocialNetwork('Snapchat')" class="social-item">
                            <img src="../assets/img/snapchat.svg" class="social-img">
                            <div class="social-info">
                                <p class="social-name">Snapchat</p>
                                <p class="social-number">{{ getSocialNetwork('Snapchat') }}</p>
                            </div>
                        </div>
                        <!-- Speedfrending ID -->
                        <div v-if="users.user.name" class="social-item">
                            <img src="../assets/img/speedfriending.svg" class="social-img">
                            <div class="social-info">
                                <div class="social-name">Speedfrending ID</div>
                                <div class="social-number">{{ users.user.name }}</div>
                            </div>
                            <img src="../assets/img/qr.svg" class="qr-code" alt="qr code">
                        </div>
                    </div>
                    <!-- description -->
                    <div v-if="users.desc != null && users.desc.length" class="user_description">
                        {{ users.desc }}
                    </div>
                    <!-- button view profile -->
                    <router-link :to="`/profile/${users.selected_user.firebase_id}`" class="tag-item action">
                        <div class="view_all tag-content">
                            <span class="tag-text view-all">{{ $t("EventPastDetails['View profile']") }}</span>
                        </div>
                    </router-link>
                    <div class="clear_both"></div>

                </div>
            </div>
        </div>
    </MainSlot>
</template>

<script>
import {mapMutations, mapGetters} from 'vuex';
import EventInfoWidget from "../components/EventInfoWidget";
import {errorMessage} from "../services/messges";
import moment from "moment-timezone";
import event_modal_data from '../store/event_modal_data.js'
import DresscodeWidget from "../components/DresscodeWidget";
import ConversationStartersWidget from "../components/ConversationStartersWidget";
import ContactPersonWidget from "../components/ContactPersonWidget";

export default {
    name: "EventPastDetails",
    components: {ContactPersonWidget, ConversationStartersWidget, EventInfoWidget, DresscodeWidget},
    data() {
        return {
            users: {
                total_count: 0,
                data: [],
                user: false,
                selected_user: {},
                tags: [],
                desc: '',
                list: [],
            },
            show_desc: false,
            desc_length: 400,
            event: {
                tags: []
            },
            modal_user: {
                modal_user: null,
                current_modal_content: {},
                available_contents: event_modal_data
            },
            desc_event: '',
            desc_event_view: false,
        };
    },
    methods: {
        ...mapMutations([
            'setLoading',
            'set_is_loaded_page',
        ]),
        async afterLoginCheckedAction() {
            this.reInitModals();
            this.loadEvent();
            this.loadUsersEvent(this.event_id);
        },
        async loadUsersEvent() {
            try {
                this.setLoading(true);
                const response = await this.$http.postAuth(`${this.$http.apiUrl()}users/event_past_users/${this.event_id}`);

                if (response.data.success) {
                    this.users.list = response.data?.data?.users || [];
                    this.users.total_count = response.data?.data?.total_count || 0;
                }
            } catch (e) {
                console.log(e);
                errorMessage(e?.response?.data?.error?.message || this.$t("validation['OOPS... Something went wrong...']"));
            }
            this.setLoading(false);
        },
        async loadEvent() {
            try {
                this.setLoading(true);
                const response = await this.$http.getAuth(`${this.$http.apiUrl()}users/events/${this.event_id}/details`);
                if (response.data.success) {
                    this.event = response.data.data;
                    this.changeDescriptionEvent();
                }
            } catch (e) {
                console.log(e);
                errorMessage(e?.response?.data?.error?.message || this.$t("validation['OOPS... Something went wrong...']"));
            }
            this.set_is_loaded_page(true);
        },
        // Modals
        reInitModals() {
            this.destroyUserModal();
            this.modal_user.modal_user = M.Modal.init(this.$refs.modal_user);
        },
        destroyUserModal() {
            if (this.modal_user.modal_user) {
                this.modal_user.modal_user?.destroy();
                this.modal_user.modal_user = null;
            }
        },
        closeUserModal() {
            this.modal_user.modal_user?.close()
        },
        openUserModal(user_id) {
            this.users.user = this.users.selected_user = this.users.list.find(user => +user.id === user_id) || {};
            this.modal_user.modal_user?.open()
            this.changeCountContent();
        },
        getAvatar(user) {
            return user?.url_avatar || '';
        },
        background_image_url(user) {
            let background = user?.background?.url ? user?.background?.url : null;
            let URL = '';

            if (background !== null) {
                URL = 'url("' + background + '")';
                URL = '' +
                    'linear-gradient(90deg, rgba(250, 96, 74, 0.467) 0%, ' +
                    'rgba(146, 53, 161, 0.467) 100%) repeat scroll 0% 0%, ' +
                    'linear-gradient(rgba(250, 96, 74, 0.95) 22.57%, ' +
                    'rgba(146, 53, 161, 0.5) 100%) repeat scroll 0% 0%, ' +
                    'white ' + URL + ' no-repeat scroll center center / cover';
            } else {
                URL = 'linear-gradient(90deg, rgb(250, 96, 74) 0%, rgb(146, 53, 161) 100%)';
            }
            return URL;
        },
        avatarBackground(user) {
            const url = user?.url_avatar || '';
            return `#fff url(${url}) no-repeat center / cover`;
        },
        getUserBackground(user) {
            let URL = '';
            if (user.background && user.background.url) {
                URL = `linear-gradient(90deg, rgba(250, 96, 74, 0.467) 0%, rgba(146, 53, 161, 0.467) 100%) `
                    + `repeat scroll 0% 0%, linear-gradient(rgba(250, 96, 74, 0.95) 22.57%, rgba(146, 53, 161, 0.5) 100%) `
                    + `repeat scroll 0% 0%, rgba(0, 0, 0, 0) url("${user?.background?.url}") `
                    + `no-repeat scroll center center / cover`;
            } else {
                URL = 'linear-gradient(90deg, rgb(250, 96, 74) 0%, rgb(146, 53, 161) 100%)';
            }
            return URL;
        },
        changeCountContent() {
            let interest = [...this.users.selected_user.interests];

            if (interest.length) {
                setTimeout(() => {
                    // number of interest tags by area size
                    this.calculatingCountTags(interest);
                }, 300);
            }

            this.users.tags = interest;
            this.users.desc = this.users.selected_user.biography;
            let count_symbols = 300;

            if (this.users.desc && this.users.desc.length > count_symbols) {
                this.users.desc = this.users.desc.substr(0, count_symbols);
                this.users.desc += '...';
            }
        },
        calculatingCountTags(interest) {
            // parent of elements
            let block_width = document.getElementById('user_soc');
            block_width = block_width.getBoundingClientRect().width;
            var allTags = document.querySelectorAll(".tags .tag-item");
            let width_tags = 10;
            let count = 0;

            for (let i = 0; i < allTags.length; i++) {
                width_tags += Math.ceil((allTags[i].getBoundingClientRect().width)) + 18;
                if (block_width > width_tags) {
                    count++;
                } else {
                    break;
                }
            }

            let new_arr = interest.slice(0);
            new_arr.length = count;
            this.users.tags = new_arr;
        },
        checkSocialNetwork(name) {
            let network = this.users.user.social;
            if (network) {
                return network.find(el => {
                    return el.title === name;
                })
            }
        },
        getSocialNetwork(name) {
            let network = this.users.user.social;
            if (network) {
                let item;
                item = network.find(el => {
                    if (el.title === name) {
                        return el;
                    }
                });
                return item.value;
            }
        },
        changeDescriptionEvent() {
            this.show_desc = !this.show_desc;
            this.desc_event = this.event?.description;

            if (this.show_desc) {
                if (this.desc_event && this.desc_event.length > this.desc_length) {
                    this.desc_event = this.desc_event.slice(0, this.desc_length) + '...';
                }
            }

            this.desc_event_view = !!(this.desc_event && this.desc_event.length > this.desc_length);
        },
    },
    computed: {
        ...mapGetters([
            'isLoginChecked',
            'is_loaded_page',
        ]),
        eventDate() {
            const date = moment(this.event.start_date_time);
            return `${date.format('MMM DD, YYYY')}`;
        },
        header_classes() {
            return 'event_details';
        },
        event_image_url() {
            return this.event && this.event.image && this.event.image.url || null;
        },
        tagsString() {
            const tags = this.event?.tags || [];
            return tags.map(el => el.title)?.join(', ') || '';
        },
    },
    watch: {
        async isLoginChecked(val) {
            if (val) {
                await this.afterLoginCheckedAction()
            }
        }
    },
    props: [
        'event_id',
    ],
    async mounted() {
        this.set_is_loaded_page(false);
        await this.$emit('check-login');
        if (this.isLoginChecked) {
            await this.afterLoginCheckedAction()
        }
    },
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";

.modal-close {
    position: absolute;
    right: 20px;
    top: 20px;
}

.less_500 {
    display: none;
}

.more_500 {
    display: block;
}

#modal_user {
    max-width: 700px;
    width: 95%;
    cursor: default;
    color: #555A63;

    .modal_header {
        position: relative;
        height: 160px;
        box-shadow: 0px -6px 29px rgb(168, 168, 168);
        border-bottom: 4px solid #FFF;

        i {
            position: absolute;
            top: 15px;
            right: 15px;
            font-size: 30px;
            cursor: pointer;
            color: white;
        }
    }

    .modal-content {

        .modal_body {
            margin-top: -130px;

            .user_info {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-content: stretch;
                align-items: flex-start;

                .user_about {
                    z-index: 1;
                    width: 100%;
                    color: #FFFFFF;
                    margin-left: 20px;

                    & > div {
                        margin-bottom: 5px;
                        white-space: nowrap;
                    }

                    .full_name {
                        font-weight: bold;
                        font-size: 26px;
                        line-height: 24px;
                        white-space: nowrap;
                    }

                    .profession {
                        font-size: 18px;
                        line-height: 24px;
                    }

                    .block-item {
                        min-width: 130px;

                        svg {
                            margin-top: 5px;
                        }

                        .block-item-text {
                            font-size: 18px;
                            line-height: 24px;
                            margin-left: 5px;
                        }
                    }
                }
            }

            .user_about.less_500 {
                z-index: 1;
                width: 100%;
                color: #555A63;
                margin: 20px auto 0px;
                display: none;

                & > div {
                    margin-bottom: 5px;
                }

                .full_name {
                    font-weight: bold;
                    font-size: 26px;
                    line-height: 24px;
                    color: black;
                    white-space: nowrap;
                }

                .profession {
                    font-size: 18px;
                    line-height: 24px;
                }

                .block-item {
                    min-width: 130px;

                    svg {
                        margin-top: 5px;
                    }

                    .block-item-text {
                        font-size: 18px;
                        line-height: 24px;
                        margin-left: 5px;
                    }
                }
            }

            .user_tags {
                margin-top: 30px;

                .tags {
                    display: flex;
                    align-items: flex-end;
                    flex-wrap: wrap;

                    .points_tag {
                        margin-bottom: 25px;
                    }
                }
            }

            .user_description {
                margin-top: 20px;
                font-size: 15px;
                line-height: 20px;
            }

            .user_soc {
                display: flex;

                & > div:first-child {
                    margin-right: 15px;
                }

                .social-item {
                    position: relative;
                    margin-top: 10px;
                    display: flex;
                    width: 50%;
                    min-width: 260px;
                    height: 70px;
                    left: 0px;
                    top: 0px;
                    background: #FFFFFF;
                    box-shadow: 3px 6px 12px rgba(58, 1, 67, 0.05);
                    border-radius: 12px;

                    .social-img {
                        width: 50px;
                        height: 50px;
                        margin-left: 10px;
                        margin-top: 10px;
                    }

                    .qr-code {
                        position: absolute;
                        right: 23px;
                        top: 23px;
                        height: 24px;
                        width: 24px;
                    }

                    .social-info {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        margin: 10px 10px;

                        .social-name {
                            font-style: normal;
                            font-weight: 600;
                            font-size: 13px;
                            line-height: 16px;
                            color: #B8B5C8;
                        }

                        .social-number {
                            font-style: normal;
                            font-weight: bold;
                            font-size: 15px;
                            line-height: 20px;
                            color: #272727;
                        }

                    }

                    p {
                        margin-block-start: 5px;
                        margin-block-end: 5px;
                    }
                }
            }
        }

        .user_ava {
            height: 155px;
            min-width: 155px;
            background-position: center center;
            background-size: cover;
            background-repeat: no-repeat;
            filter: drop-shadow(3px 6px 12px rgba(58, 1, 67, 0.15));
            border-radius: 24px;
            border: 4px solid #FFFFFF;
        }
    }

}

.tag-item {
    width: fit-content;
    margin: 0px 18px 18px 0px;
    background: #FFFFFF;
    box-shadow: 3px 6px 12px rgba(58, 1, 67, 0.05);
    border-radius: 12px;
    padding: 15px 7px 12px 15px;

    &.action {
        cursor: pointer;
        z-index: 1;
        margin: 15px 0px 0px 0px;
        float: right;
    }

    svg {
        width: 12px;
        height: 12px;
        min-width: 12px;
    }

    .tag-content {
        display: flex;
    }

    .tag-text {
        width: max-content;
        margin-top: -4px;
        margin-left: 6px;
        padding-right: 10px;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 20px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #555A63;

        &.view-all {
            margin-left: 0;
            font-style: normal;
            font-weight: bold;
            font-size: 15px;
            line-height: 20px;
            display: flex;
            align-items: center;
            text-align: center;
            color: #FA604A;

        }
    }
}

.clear_both {
    clear: both;
}

.tags_wrapper {
    margin: 30px 0;
    padding: 0px;
}

.page_bg {

    .main_event {
        justify-content: center;
        align-items: center;
        display: flex;
        flex-direction: column;
        margin-top: -350px;

        .top_event {

            .event_text {
                margin-bottom: 25px;
                font-style: normal;
                font-weight: bold;
                font-size: 18px;
                line-height: 24px;
                /* identical to box height, or 133% */
                align-items: center;
                /* snow-trans50 */
                color: rgba(255, 255, 255, 0.5);
            }

            .card_wrapper {
                position: relative;
                filter: drop-shadow(3px 6px 12px rgba(58, 1, 67, 0.15));

                img {
                    height: auto;
                    max-height: 600px;
                    width: auto;
                    padding: 0;
                    margin: 0;
                    line-height: 0;
                    border-radius: 12px;
                    overflow: hidden;
                    max-width: 100%;
                }

                .content_info {
                    position: absolute;
                    bottom: 15px;
                    left: 27px;
                    color: #FFFFFF;
                    font-weight: bold;
                    font-size: 29px;
                }
            }
        }

        .second_row {

            .block_dress_desc {
                width: 100%;
                max-width: calc(66% - 20px);
                float: left;

                & > div {
                    width: 100%;
                }

                .desc_view {
                    width: 85px;
                    margin-bottom: 35px;
                }
            }

            .right_col {
                width: 33.3333333333%;
                float: right;
            }
        }
    }

    .block_friends {
        width: calc(66% - 20px);
        float: left;

        .list_friends {

            .title_friends {
                display: flex;
                margin: 5px 0px 15px 0px;

                svg {
                    margin-right: 10px;
                }

                & > div {
                    font-weight: 700;
                    font-size: 22px;
                    line-height: 25px;
                }
            }

            .align_block {

                & > div:nth-child(1n) {
                    padding-left: 0px;
                }

                & > div:nth-child(2n) {
                    padding-left: 12px;
                    padding-right: 0px;
                }

                .align_friend {
                    display: flex;
                    justify-content: center;
                    margin-bottom: 20px;

                    .friend-item {
                        /*max-width: 280px;*/
                        width: 100%;
                        box-shadow: 3px 6px 12px 0px #3A01430D;
                        border-radius: 15px;
                        cursor: pointer;

                        .first-block {
                            background: linear-gradient(90deg, rgb(250, 96, 74) 0%, rgb(146, 53, 161) 100%);
                            height: 145px;
                            border-radius: 12px 12px 0 0;
                            background-position: center center;
                            background-size: cover;
                            background-repeat: no-repeat;

                            .image-block {
                                padding-top: 30px;

                                .avatar-image {
                                    height: 160px;
                                    width: 160px;
                                    border: 4px solid #FFFFFF;
                                    box-sizing: border-box;
                                    margin: 0 auto;
                                    filter: drop-shadow(3px 6px 12px rgba(58, 1, 67, 0.15));
                                    border-radius: 24px;
                                    background: white center center / cover no-repeat;
                                }
                            }
                        }

                        .second-block {
                            background: linear-gradient(#DADEED, white);
                            height: 61px;
                        }

                        .third-block {
                            background: #FFF;
                            border-radius: 0 0 12px 12px;

                            .name {
                                text-align: center;
                                font-weight: bold;
                                font-size: 22px;
                                color: #FA604A;
                                margin-bottom: 2px;
                            }

                            .event-meet {
                                font-size: 15px;
                                text-align: center;
                                color: #25262b;
                                width: 100%;
                                margin: 0 auto 5px auto;

                                span {
                                    font-weight: bold;
                                }
                            }

                            .block-item {
                                text-align: center;
                                padding-bottom: 30px;

                                .text {
                                    margin-left: 6px;
                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 15px;
                                    line-height: 20px;
                                    align-items: center;
                                    color: #555A63;
                                }

                            }
                        }

                    }
                }
            }
        }
    }
}

.sidebar {

    & > div {
        margin-bottom: 30px;
    }

}

#delete_event_modal {
    p {
        padding: 30px 50px;
    }
}

.row {
    width: 100%;
    margin-bottom: 0;
}

.buttons_wrapper_between {
    position: relative;

    .btn {
        min-width: calc(50% - 15px);

        img {
            height: 15px;
        }
    }
}

.ev_description {
    margin: 30px 0;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    color: #555A63;
    overflow-wrap: anywhere;
}

.img_preview {
    width: 100%;
    text-align: center;
    height: 50vh;
    margin: 0 0 30px;
    line-height: 0;

    img {
        height: 100%;
        border-radius: 24px;
        overflow: hidden;
        width: auto;
    }
}

.details_row {
    width: 100%;
    padding-top: 30px;
}

.brand {
    color: $brand_color;
    padding-bottom: 24px;
}

.tags_title {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    padding-top: 24px;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    color: #555A63;

    img {
        padding-right: 6px;
    }
}

.flex_vertical {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: stretch;
    align-items: center;

    .text-action {
        width: 90px;
        background: #FFFFFF;
        box-shadow: 3px 6px 12px rgba(58, 1, 67, 0.05);
        border-radius: 12px;
        padding: 13px 0px;
        cursor: pointer;
        font-weight: bold;
        font-size: 15px;
        color: #FA604A;
        text-align: center;
    }
}

.modal:not(.datepicker-modal, .timepicker-modal) .modal-content p {
    padding: 0px !important;
}

@media screen and (max-width: 992px) {

    .row .col {
        padding: 0px;
    }
    .second_row {
        .right_col {
            margin-top: 30px;
        }
    }
    .page_bg {
        .block_friends {
            width: 100%;
            max-width: 100%;

            .list_friends {
                .title_friends {
                    margin: 35px 0px 15px 0px;
                }

                .align_block .align_friend:nth-child(2n) {
                    padding-left: 20px;
                }
            }
        }
    }

}

@media screen and (max-width: 601px) {
    .page_bg {

        .main_event {
            margin-top: -115px;
            padding: 0px 20px;

            .top_event {

                .card_wrapper {
                    .content_info {
                        font-size: 24px;
                    }
                }
            }

            .tags_wrapper {
                margin: 15px 0;
            }

            .second_row {
                display: flex;
                flex-direction: column;

                .block_dress_desc {
                    max-width: 100%;
                    float: none;

                    .desc_view {
                        margin-bottom: 20px;
                    }
                }

                .right_col {
                    padding-bottom: 15px;
                    margin-top: 8px;
                    width: 100%;
                    float: none;
                }

                .block_friends {
                    float: none;

                    .title_friends {
                        margin: 20px 0px 15px 0px;
                    }

                    .align_block .align_friend:nth-child(2n) {
                        padding-left: 0px;
                    }
                }
            }
        }
    }

    .ev_description {
        margin: 15px 0;
    }
    #modal_user {
        .modal-content {
            .modal_body {
                .user_soc {
                    flex-wrap: wrap;
                    justify-content: center;

                    & > div:first-child {
                        margin-right: 0px;
                    }
                }
            }
        }
    }
}

@media screen and (max-width: 500px) {
    .less_500 {
        display: block;
    }
    .more_500 {
        display: none;
    }
    #modal_user {
        .modal-content {
            .user_ava {
                height: 175px;
                width: 175px;
            }

            .modal_body {
                .user_info {
                    justify-content: center;
                }

                .user_about {
                    margin: 20px auto 0px;
                    width: 170px;

                    .full_name, .profession {
                        text-align: center;
                    }

                    .full_name {
                        margin-bottom: 10px;
                    }

                    .less_500 {
                        .block-item {

                        }
                    }

                }
            }
        }
    }

    #modal_user .modal-content .modal_body {
        .user_tags {
            margin-top: 25px;
        }

        .user_about.less_500 {
            display: flex;
            flex-direction: column;
            align-items: center;

            .block-item {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-content: stretch;
                align-items: center;
                margin-bottom: 5px;

                svg {
                    margin-top: 0px;
                }
            }
        }

    }


}

@media screen and (max-width: 460px) {
    #modal_user {
        .modal-content {
            .modal_body {
                .user_soc {
                    .social-item {
                        width: 100%;
                    }
                }
            }
        }
    }
}

</style>
